<template lang="pug">
v-menu.expand-menu__container(
  v-model="isMenuOpen"
  :content-class="menuClasses"
  v-bind="expandedAttrs"
)
  template(#activator="{ attrs, on, value }")
    slot(name="activator" :on="on" :attrs="getAttrs(attrs)" :value="value")
  slot
</template>

<script>
export const MENU_TYPES = {
  DEPEND: 'depend',
  INDEPEND: 'independ',
};

export default {
  name: 'ExpandMenu',

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    preventDefaultStyle: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: MENU_TYPES.DEPEND,
    },
    additionalMenuClasses: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      activatorId: `${new Date().getTime()}`,
    };
  },

  computed: {
    expandedAttrs() {
      return {
        'offset-y': true,
        ...this.$attrs,
      };
    },
    menuClasses() {
      return `expand-menu__menu expand-menu__menu--${this.type} ${this.additionalMenuClasses}`;
    },
    isMenuOpen: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      },
    },
  },

  methods: {
    getAttrs(attrs) {
      return {
        ...attrs,
        activator: this.activatorId,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.expand-menu__container::v-deep .v-menu__content {
  box-shadow: none !important;
}
.expand-menu {
  &__container {
  }
  &__activator {}
  &__menu {
    margin-top: 8px;

    &--wrap {
      z-index: 100;
      position: absolute;
      top: 0;
      transform-origin: top;
      min-width: 100%;
    }
    overflow: hidden;
    background: #{$redesignControlsBackground};
    &--depend {
      box-shadow: 0px 1px 1px rgba(41, 41, 47, 0.16) !important;
      border-radius: 0px 0px 8px 8px !important;
    }
    &--independ {
      // box-shadow: 0px 0px 4px rgba(17, 24, 28, 0.16);
      box-shadow: none;
      border-radius: 32px;
    }
  }
}
</style>
